export const defaultMergeItems = <TItem>(prev: TItem[], next: TItem[]) =>
  prev.concat(next);
